<template>
  <q-btn
    no-caps
    color="grey-5"
    :bg-color="!$q.dark.isActive ? 'white' : 'black'"
    outline
    class="q-py-sm"
  >
    <span
      v-if="useValuesForLabel ? min === null && max === null : true"
      style="font-weight: 400; font-size: small"
      :class="!$q.dark.isActive ? 'text-black' : 'text-white'"
    >
      <slot></slot>
    </span>
    <span
      v-if="min !== null && max !== null"
      style="font-weight: 400"
      :style="useValuesForLabel ? { 'font-size': 'small' } : { 'font-size': 'x-small' }"
      class="q-ml-sm"
      :class="!$q.dark.isActive ? 'text-black' : 'text-white'"
    >
      <span v-if="!useValuesForLabel"> ( </span>
      <span v-if="rawNumbers"> {{ min }} {{ unit }} - {{ max }}{{ unit }} </span>
      <span v-else> {{ formatNumber(min) }} {{ unit }} - {{ formatNumber(max) }}{{ unit }} </span>
      <span v-if="!useValuesForLabel"> ) </span>
    </span>
    <span
      v-else-if="min !== null"
      style="font-weight: 400"
      :style="useValuesForLabel ? { 'font-size': 'small' } : { 'font-size': 'x-small' }"
      class="q-ml-sm"
      :class="!$q.dark.isActive ? 'text-black' : 'text-white'"
    >
      <span v-if="!useValuesForLabel"> ( </span>
      <span v-if="rawNumbers"> &gt; {{ min }}{{ unit }} </span>
      <span v-else> &gt; {{ formatNumber(min) }}{{ unit }} </span>
      <span v-if="!useValuesForLabel"> ) </span>
    </span>
    <span
      v-else-if="max !== null"
      style="font-weight: 400"
      :style="useValuesForLabel ? { 'font-size': 'small' } : { 'font-size': 'x-small' }"
      class="q-ml-sm"
      :class="!$q.dark.isActive ? 'text-black' : 'text-white'"
    >
      <span v-if="!useValuesForLabel"> ( </span>
      <span v-if="rawNumbers"> &lt; {{ max }}{{ unit }} </span>
      <span v-else> &lt; {{ formatNumber(max) }}{{ unit }} </span>
      <span v-if="!useValuesForLabel"> ) </span>
    </span>
    <min-max-popover
      :title="title"
      :no-apply-btn="noApplyBtn"
      :min-value="min"
      :max-value="max"
      @hide="handleHide"
      @update-range="handleRangeUpdate"
    >
      <template #help-text>
        <span v-if="helpText">
          {{ helpText }}
        </span>
      </template>
    </min-max-popover>
  </q-btn>
</template>

<script lang="ts">
import MinMaxPopover from '@/components/PropertyReports/MinMaxPopover.vue'
import type { PropType } from 'vue'
import { formatNumber } from '@/utils'

export default {
  name: 'MinMaxFilter',
  components: { MinMaxPopover },
  props: {
    title: {
      type: String as PropType<string>,
      required: true
    },
    min: {
      type: Number as PropType<number | null>,
      default: null
    },
    max: {
      type: Number as PropType<number | null>,
      default: null
    },
    unit: {
      type: String as PropType<string | null>,
      default: null,
      required: false
    },
    // flag for not formatting numbers (e.g. year_built should not have a comma)
    rawNumbers: {
      type: Boolean as PropType<boolean>,
      default: false,
      required: false
    },
    noApplyBtn: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    useValuesForLabel: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    helpText: {
      type: String as PropType<string | null>,
      default: null,
      required: false
    }
  },
  emits: ['update-range', 'hide'],
  methods: {
    formatNumber,
    handleRangeUpdate(range: { min: number | null; max: number | null }) {
      this.$emit('update-range', range)
    },
    handleHide(range: { min: number | null; max: number | null }) {
      this.$emit('hide', range)
    }
  }
}
</script>
